import { render, staticRenderFns } from "./PaymentUpload.vue?vue&type=template&id=2b63a126"
import script from "../../services/student/payment-upload.js?vue&type=script&lang=js&external"
export * from "../../services/student/payment-upload.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/video-upload.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports